import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  createRejectionReasonItemService,
  deleteRejectionReasonItemService,
  editRejectionReasonItemService,
  getRejectionReasonItemsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const rejectionReasonAdminContext = createContext({
  rejectionReasonItems: [],
  setRejectionReasonItems: () => {},
  rejectionReason: {},
  setRejectionReason: () => {},
  id: "",
  setId: () => {},
  reason: "",
  setReason: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetRejectionReasonItemList: () => {},
  handleCreateRejectionReasonItem: () => {},
  handleEditRejectionReasonItem: () => {},
  handleDeleteRejectionReasonItem: () => {},
});

const RejectionReasonAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [rejectionReasonItems, setRejectionReasonItems] = useState([]);
  const [rejectionReason, setRejectionReason] = useState({});
  const [id, setId] = useState("");
  const [reason, setReason] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  const handleResetState = () => {
    setId("");
    setReason("");
  };

  // Create User Satisfaction Modal Operations
  const handleShowModal = (itemValue) => {
    setIsShowModal(true);
    if (itemValue) {
      setId(itemValue.id);
      setReason(itemValue.reason);
    }
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Details User Satisfaction Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setRejectionReason(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setRejectionReason({});
  };

  // Handle Get User Satisfaction Item List Method
  const handleGetRejectionReasonItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getRejectionReasonItemsService(objData);
      if (status === 200) {
        setRejectionReasonItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create User Satisfaction Item Method
  const handleCreateRejectionReasonItem = async (event) => {
    event?.preventDefault();

    const objData = {
      reason,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createRejectionReasonItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetRejectionReasonItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit User Satisfaction Item Method
  const handleEditRejectionReasonItem = async (event) => {
    event?.preventDefault();

    const objData = {
      id,
      reason,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editRejectionReasonItemService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ویرایش شد");
        handleGetRejectionReasonItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete User Satisfaction Item Method
  const handleDeleteRejectionReasonItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteRejectionReasonItemService(id);
      if (status === 204) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetRejectionReasonItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <rejectionReasonAdminContext.Provider
      value={{
        rejectionReasonItems,
        setRejectionReasonItems,
        rejectionReason,
        setRejectionReason,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        id,
        setId,
        reason,
        setReason,
        isShowModal,
        setIsShowModal,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetRejectionReasonItemList,
        handleCreateRejectionReasonItem,
        handleEditRejectionReasonItem,
        handleDeleteRejectionReasonItem,
      }}
    >
      {children}
    </rejectionReasonAdminContext.Provider>
  );
};

export default RejectionReasonAdminContext;
